module.exports = __webpack_public_path__ + "img/project10_13.jpg.23c7dd6f.webp";